export default "__VITE_PUBLIC_ASSET__30185c17__"